module.exports = __webpack_public_path__ + "img/10.8e0b735d.png";